import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from './user.service';
import { AUTH_SERVER_ADDRESS } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {

	public currentToken!: Observable<String | null>;
	public currentTokenSubject = new BehaviorSubject<String | null>(null);

	isLoggedIn = new BehaviorSubject(null);
	private _storage: Storage | null = null;

	constructor(
		private httpClient: HttpClient,
		private userService: UserService,
		private storage: Storage,
		private plt: Platform,
	) {
		this.plt.ready().then(() => {
			this.init();
		});
	}

	async init() {
		console.log('Init Auth Service');
		const storage = await this.storage.create();
		this._storage = storage;
		const token = await storage.get('TOKEN_KEY');

		if (token) {
			this.currentTokenSubject.next(token);
			this.currentToken = this.currentTokenSubject.asObservable();

			// Validar el token haciendo una llamada a la API
			this.userService.syncUserActivo().subscribe(
				(response) => {
					// Token válido, usuario sincronizado correctamente
					this.isLoggedIn.next(token);
					console.log('Token válido, usuario sincronizado');
				},
				(error) => {
					// Token inválido o caducado
					console.log('Token inválido o caducado, haciendo logout');
					this.logout();
				}


				/*
					  if (this.plt.is('ios')) {
						  this.firebaseX.grantPermission()
							  .then(hasPermission => {
								  console.log("Permission was " + (hasPermission ? "granted" : "denied"));
								  this.firebaseX.getAPNSToken()
									  .then(token => {
										  console.log(`The apn token (auth init) is ${token}`)
									  })
									  .catch(error => {
										  console.error('Error getting apn token', error);
									  });
							  });

					  }
					  this.firebaseX.getToken()
						  .then(token => {
							  console.log(`The firebase token (auth init) is ${token}`)
							  this.userService.updateFirebaseToken({firebase_token: token});
						  })
						  .catch(error => {
							  console.error('Error getting token', error);
						  });
				  */


			);
		} else {
			this.isLoggedIn.next(null);
			await storage.clear();
		}
	}

	login(credentials: any) {

		const formData = new FormData();
		formData.append('username', credentials.username);
		formData.append('password', credentials.password);

		const headers = {
			'Accept': 'application/json',
			'Accept-Language': 'es-ES,es;q=0.8,en-US;q=0.5,en;q=0.3',
			'Origin': window.location.origin
		};
		return this.httpClient.post(`${AUTH_SERVER_ADDRESS}/login`, formData, { headers, withCredentials: false }).pipe(
			tap(async (res: any) => {
				if (res) {

					this.isLoggedIn.next(res['token']);
					await this.storage.set('TOKEN_KEY', res['token']);
					this.userService.setUserActivo(res['usuario']);
					this.currentTokenSubject.next(res['token']);

					/*
							  if (this.plt.is('ios')) {
								  this.firebaseX.grantPermission()
									  .then(hasPermission => {
										  console.log("Permission was " + (hasPermission ? "granted" : "denied"));
										  this.firebaseX.getAPNSToken()
											  .then(token => {
												  console.log(`The apn token (auth init) is ${token}`)
											  })
											  .catch(error => {
												  console.error('Error getting apn token', error);
											  });
									  });
								  }
							  this.firebaseX.getToken()
								  .then(token => {
									  console.log(`The firebase token (login) is ${token}`)
									  this.userService.updateFirebaseToken({firebase_token: token});
								  })
								  .catch(error => {
									  console.error('Error getting token', error);
								  });
							  }
					*/
				}
			})
		);
	}

	logout() {
		return this.storage.remove('TOKEN_KEY').then(() => {
			// Limpiar el token actual
			this.currentTokenSubject.next(null);
			this.isLoggedIn.next(null);
			// Limpiar datos de usuario
			this.userService.delUserActivo();
		});
	}

	async getToken() {
		const token = await this.storage.get('TOKEN_KEY');
		return token;
	}
}